import { memo, useCallback, useState } from 'react'
import IconError from 'assets/error.svg?react'
import IconRemove from 'assets/remove.svg?react'
import IconSuccess from 'assets/success.svg?react'
import cn from 'classnames'
import noop from 'lodash/noop'

import s from './Notification.module.less'

type TIconType = 'error' | 'warning' | 'debug' | 'info' | 'success' | 'log'

const iconByType = (type?: TIconType) => {
  if (type === 'success') {
    return IconSuccess
  }

  if (type === 'error') {
    return IconError
  }

  return null
}

export interface INotification {
  type: TIconType
  closable?: boolean
  description?: string
  timeout?: number
  title?: string
}

export interface INotificationProps {
  notification: INotification
  onRemove?: (notification: INotification) => void
}

export const Notification = memo(function Notification({ notification, onRemove = noop }: INotificationProps) {
  const [isCursorOnNotification, setIsCursorOnNotification] = useState(false)

  const { closable = true, description, timeout = 5000, title, type } = notification

  const handleRemove = useCallback(() => {
    if (closable) {
      onRemove(notification)
    }
  }, [closable, notification, onRemove])

  const handleMouseEnter = useCallback(() => {
    setIsCursorOnNotification(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsCursorOnNotification(false)
  }, [])

  const Icon = iconByType(type)

  return (
    <div
      // Атрибут data-test="notification" необходим для корректного закрытия нотификации относительно модалок
      data-test="notification"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={cn(s.wrapper, {
        [s.wrapper_type_error]: type === 'error',
        [s.wrapper_type_success]: type === 'success'
      })}
    >
      <div className={s.notification} data-component="modal">
        <div className={s.icon}>
          <div className={s.icon}>{Icon && <Icon />}</div>
        </div>
        {closable && (
          <div className={s.close}>
            <IconRemove onClick={handleRemove} />
          </div>
        )}
        <div className={s.title}>{title}</div>
        {description && <div className={s.description}>{description}</div>}
      </div>
      <div
        className={s.progress}
        onAnimationEnd={handleRemove}
        style={{
          animationDuration: `${timeout}ms`,
          animationPlayState: isCursorOnNotification ? 'paused' : 'running'
        }}
      />
    </div>
  )
})
